module.exports = __webpack_public_path__ + "6fbcc023e948d7dd914f1c7fccf94d76.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/close-white.svg
// module id = 487
// module chunks = 74